import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fs16 fw600" }, "カレンダーに登録するイベント情報", -1)
const _hoisted_3 = { class: "fl ml2 w100 mt20" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "fl mr10" }, "件名", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { class: "fl ml2 w100 mt40" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "fl mr10" }, "内容", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VariableListsContent = _resolveComponent("VariableListsContent")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!

  return (_ctx.rcm.room_setting)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _hoisted_4,
              _createElementVNode("div", {
                class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addVal(`title`)))
              }, "+変数を追加"),
              _hoisted_5
            ]),
            _createElementVNode("div", null, [
              (_ctx.openTitleVariables)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_VariableListsContent, {
                      onSelectVariable: _ctx.selectVariable,
                      type: `title`
                    }, null, 8, ["onSelectVariable"]),
                    _hoisted_7
                  ]))
                : _createCommentVNode("", true),
              _hoisted_8
            ]),
            _createVNode(_component_TextfieldTag, {
              placeholder: `${_ctx.Util.thanksPageDefaultTitle}`,
              style: {"height":"50px"},
              class: _normalizeClass(`fl fs14 roundForm mw100`),
              value: _ctx.rcm.room_setting.provider_event_title,
              onInputValue: _ctx.inputEventTitle
            }, null, 8, ["placeholder", "value", "onInputValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _hoisted_10,
              _createElementVNode("div", {
                class: "pointer fr rad6 borderGrey hoverGrey fs12 padw3",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addVal(`desc`)))
              }, "+変数を追加"),
              _hoisted_11
            ]),
            _createElementVNode("div", null, [
              (_ctx.openDescriptionVariables)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_VariableListsContent, {
                      onSelectVariable: _ctx.selectVariable,
                      type: `desc`
                    }, null, 8, ["onSelectVariable"]),
                    _hoisted_13
                  ]))
                : _createCommentVNode("", true),
              _hoisted_14
            ]),
            _createVNode(_component_TextareaTag, {
              placeholder: `${_ctx.Util.thanksPageDefaultContent}`,
              style: {"height":"120px"},
              class: _normalizeClass(`fl fs14 roundForm mw100`),
              value: _ctx.rcm.room_setting.provider_event_description,
              onInputValue: _ctx.inputEventDescription
            }, null, 8, ["placeholder", "value", "onInputValue"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}